import React from 'react';
import { FormBuilder, Loader } from 'commons-ui';
import useEdit from './useEdit';
import { FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG, validationSchemaEdit } from '../../utils/formConfig';
import { styles } from './editTdsConfig.style';
import SegmentMap from './SegmentMap';

const EditConfig: React.FC<{}> = () => {
	const { configData, showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useEdit();
	return (
		<div style={styles.mainContainer}>
			{showLoader && <Loader />}
			<div style={styles.priorityList}>
				<h2>Live Segments</h2>
				<SegmentMap segments={configData?.liveSegmentList} />
			</div>
			<div style={styles.priorityList}>
				<h2>User Segments</h2>
				<SegmentMap segments={configData?.userSegmentList} />
			</div>

			{configData?.customAbsorptionAmount && (
				<FormBuilder
					data={configData}
					mode='edit'
					showLoader={showLoader}
					handleFormSubmit={handleFormSubmit}
					handleFormCancel={handleFormCancel}
					setShowLoader={setShowLoader}
					fieldConfig={FORM_FIELD_CONFIG}
					layoutConfig={FORM_LAYOUT_CONFIG}
					validationSchema={validationSchemaEdit}
				/>
			)}
		</div>
	);
};

export default EditConfig;
